import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class layoutServices extends ApiBaseService {
    constructor(public http: HttpClient) {
        super(http, '/layouts');
    }
    checkNameExists(name: string, id?: boolean | number): Observable<any> {
        const layoutId = id ? id : null;
        const params = { name, layoutId };
        return this.http.get(`${environment.apiUrl}/layouts/check`, {
            params,
        });
    }

    getTemplates(): Observable<any> {
        return this.http.get(`${environment.apiUrl}/layouts/templates`, {});
    }

    uploadFiles(body: FormData): Observable<any> {

        return this.http.post(`${environment.apiUrl}/layouts/uploadFiles`, body, {});
    }

    deleteFile(id: string): Observable<any> {

        return this.http.delete(`${environment.apiUrl}/layouts/deleteFile/${id}`);
    }
}
